import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { createPortal } from "react-dom";

export function ToastNotice({ message }: { message: string }) {
  const reduced = useReducedMotion();
  return createPortal(<div className="toast-position"><AnimatePresence>{message && <motion.div
    className="toast" role="status" aria-live="polite"
    initial={reduced ? false : { opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: reduced ? 0 : 8 }} transition={{ duration: reduced ? 0 : .18 }}
  >{message}</motion.div>}</AnimatePresence></div>, document.body);
}
